import * as React from "react";
import { Form, Input, Checkbox } from "antd";
import { RequestTypeFormFields } from "../../../common/Constants";
import { IRequestType } from "../../../model/request/RequestType";

const RequestTypeForm = ({
  getFieldDecorator,
  translate,
  rowData
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: IRequestType;
}) => {
  return (
    <Form>
      <Form.Item label={translate("requestType_form.code")}>
        {getFieldDecorator(RequestTypeFormFields.Fields.CODE, {
          initialValue: rowData && rowData.code,
          rules: [
            {
              required: true,
              message: translate("requestType_form.required_messages", {
                field: translate("requestType_form.code")
              })
            }
          ]
        })(<Input readOnly={rowData ? true : false} />)}
      </Form.Item>
      <Form.Item label={translate("requestType_form.name")}>
        {getFieldDecorator(RequestTypeFormFields.Fields.NAME, {
          initialValue: rowData && rowData.name,
          rules: [
            {
              required: true,
              message: translate("requestType_form.required_messages", {
                field: translate("requestType_form.name")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label={translate("requestType_form.valid")}>
        {getFieldDecorator(RequestTypeFormFields.Fields.VALID, {
          valuePropName: "checked",
          initialValue: rowData ? rowData.valid : true,
          rules: [
            {
              required: true,
              message: translate("requestType_form.required_messages", {
                field: translate("requestType_form.valid")
              })
            }
          ]
        })(<Checkbox />)}
      </Form.Item>
    </Form>
  );
};

export default RequestTypeForm;
